module.exports = __webpack_public_path__ + "img/gatherInfo.4f8e6e54.svg";